import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import state from './state'
import actions from './actions'
import getters from './getters'
import vuexI18n from 'vuex-i18n'
Vue.use(Vuex)
export default new Vuex.Store({
	state,
	getters,
	actions,
	mutations,
  modules: {
    i18n: vuexI18n.store
  }
})
